import { Button } from '@material-tailwind/react';

const Adicionar = ({ text, type, click, error = false }) => {
  return (
    <>
      <Button color="green" type={type} onClick={() => click()}>
        {text}
      </Button>
    </>
  );
};

export default Adicionar;
